import React, { useEffect, useState } from "react";
import { Offcanvas, Button, Spinner, Dropdown } from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import user from "../../../assets/svg/User.svg";
import { getFuelHistDetAPI } from "./FuelHistoryApi";
import { useGlobal } from "../../../GlobalContext.js";

const FuelHistoryView = ({ id, showEdit, showDelete, show, handleClose }) => {
   const { rolePermissionList, userType } = useGlobal();
  useEffect(() => {
    console.log("Consilee ID", id);
    if (id !== undefined && id !== null && id !== 0) {
      console.log("Consilee", id);
      getFuelHistoryView();
    }
  }, [id]);

  const [fuelHistoryView, setFuelHistoryView] = useState(null);
  const getFuelHistoryView = async () => {
    try {
      const response = await getFuelHistDetAPI(id);

      console.log("Km  details", response);
      if (response.data?.success) {
        const vehicleData = response.data.history;
        setFuelHistoryView(vehicleData);
      } else {
        console.error(
          "Failed to fetch vehicle details:",
          response.data?.message
        );
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      style={{ width: "520px" }}
    >
      <Offcanvas.Header
        closeButton={false}
        className="d-flex justify-content-between align-items-center p-0"
      >
        <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
          <div>
            <p className="m-0 fs-20 fw-800 mb-1">
              {" "}
              {fuelHistoryView?.lic_no ?? "-"}
            </p>
            <div className="d-flex align-items-center">
              <span className="me-2 text-muted-grey fs-13 fw-600">
                {fuelHistoryView?.name ?? "-"}
              </span>
              <span className="me-2" style={{ color: "#D9D9D9" }}>
                •
              </span>
              <span className="border-0 bg-white text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400">
                <span className="text-muted-grey"> VIN : </span>
                {fuelHistoryView?.vin ?? "-"}
              </span>
            </div>
          </div>
          <div className="d-flex gap-3">
            {checkPermission("Fuel History", "edit_permission") &&(<img
              src={edit}
              alt="edit"
              className="cursor-pointer"
              onClick={() => {
                handleClose();
                showEdit(id);
              }}
            />)}
            {checkPermission("Fuel History", "delete_permission") &&(<img
              src={trash}
              alt="trash"
              className="cursor-pointer"
              onClick={() => {
                handleClose();
                showDelete(id);
              }}
            />)}

            <img
              src={closeoff}
              alt="closeoff"
              className="cursor-pointer"
              onClick={handleClose}
            />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          <p className="m-0 fs-15 fw-600">Other details</p>
          <div className="table-container rounded-4 overflow-hidden my-3">
            <table className="table table-borderless mb-0">
              <tbody>
                <tr>
                  <td
                    className="fs-13 fw-500"
                    style={{ color: "#49494B", width: "25%" }}
                  >
                    Fuel type
                  </td>
                  <td
                    className="fs-13 fw-400"
                    style={{ color: "#172B4D", width: "75%" }}
                  >
                    {fuelHistoryView?.fuel_type ?? "-"} km
                  </td>
                </tr>
                <tr>
                  <td
                    className="fs-13 fw-500"
                    style={{ color: "#49494B", width: "25%" }}
                  >
                    Last Km while fueling
                  </td>
                  <td
                    className="fs-13 fw-400"
                    style={{ color: "#172B4D", width: "75%" }}
                  >
                    {fuelHistoryView?.last_km ?? "-"} km
                  </td>
                </tr>

                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Current Km while fueling
                  </td>
                  <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                    {fuelHistoryView?.current_km ?? "-"} km
                  </td>
                </tr>
                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Fuel qty (ltrs)
                  </td>
                  <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                    {fuelHistoryView?.qty ?? "0"}{" "}
                    <span style={{ fontSize: "12px", color: "#8790A1" }}>
                      Liters
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Fuel price
                  </td>
                  <td
                    className="fs-13 fw-400 d-flex align-items-center"
                    style={{ color: "#172B4D", gap: "8px" }}
                  >
                    <div>
                      {" "}
                      {fuelHistoryView?.price ?? "0"}
                      <span style={{ fontSize: "12px", color: "#8790A1" }}>
                        {" "}
                        /Liter
                      </span>{" "}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                    Total price
                  </td>
                  <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                    ₹ {fuelHistoryView?.total_price ?? "0"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <p className="m-0 pagination-color fs-15 fw-600">Attached image</p>
          {fuelHistoryView?.image && (
            <div className="receipt-container position-relative">
              <img
                src={fuelHistoryView.image}
                alt="Receipt"
                className="receipt-image"
              />
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default FuelHistoryView;
